export class LottoSpedizione {
    idLottoSpedizione: number;
    numeroLottoSpedizione: string;
    tipoProdotto: string;
    numeroProdotti: number;
    statoLotto: number;
    pdrSpedizione: string;
    destinatarioSpedizione: string;
    indirizzoSpedizione: string;
    pressoSpedizione: string;
    localitaSpedizione: string;
    provinciaSpedizione: string;
    capSpedizione: string;
    codErroreConsegna: number;
    dxErroreConsegna: string;
    corriere: string;
    trackingId: string;
    recVer: number;

    constructor() {
        this.idLottoSpedizione = null;
        this.numeroLottoSpedizione = null;
        this.tipoProdotto = null;
        this.numeroProdotti = null;
        this.statoLotto = null;
        this.pdrSpedizione = null;
        this.destinatarioSpedizione = null;
        this.indirizzoSpedizione = null;
        this.pressoSpedizione = null;
        this.localitaSpedizione = null;
        this.provinciaSpedizione = null;
        this.capSpedizione = null;
        this.codErroreConsegna = null;
        this.dxErroreConsegna = null;
        this.corriere = null;
        this.trackingId = null;
        this.recVer = 0;
    }
}

export enum LottoSpedizione_Stato {
    Richiesto = 1,
    DaEvadere = 2,
    Spedito = 3,
    NotificaSpedito = 4,
    Consegnato = 5,
    NonConsegnato = 6,
    NotificaConsegnato = 7,
    NotificaNonConsegnato = 8,
    DaRispedire = 9,
    DaComporre = 10
}


// WEBPACK FOOTER //
// ./src/app/_models/lotto-spedizione.ts